exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SortOption__sortIcon___1LhBU {\n  margin-right: 8px;\n  width: 14px;\n  height: 14px; }\n\n.SortOption__sortOptionContainer___3qm-n {\n  display: inline-block; }\n  @media (max-width: 768px) {\n    .SortOption__sortOptionContainer___3qm-n {\n      display: block; } }\n  .SortOption__sortOptionContainer___3qm-n > div {\n    width: 240px; }\n\n.SortOption__item___1Oziw {\n  display: flex;\n  align-items: center;\n  padding-bottom: 9px;\n  padding-top: 9px; }\n", ""]);

// exports
exports.locals = {
	"sortIcon": "SortOption__sortIcon___1LhBU",
	"sortOptionContainer": "SortOption__sortOptionContainer___3qm-n",
	"item": "SortOption__item___1Oziw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SortOption/styles/SortOption.scss
// module id = 4282
// module chunks = 6